export const UPDATE_INPUT_TERM = 'UPDATE_INPUT_TERM';
export const UPDATE_SEARCH_SELECTION = 'UPDATE_SEARCH_SELECTION';
export const UPDATE_INPUT_CUI = 'UPDATE_INPUT_CUI';

export const SEARCH_TERMS_STARTED = 'SEARCH_TERMS_STARTED';
export const SEARCH_TERMS_SUCCEEDED = 'SEARCH_TERMS_SUCCEEDED';
export const SEARCH_TERMS_FAILED = 'SEARCH_TERMS_FAILED';

export const SEARCH_CUI_STARTED = 'SEARCH_CUI_STARTED';
export const SEARCH_CUI_SUCCEEDED = 'SEARCH_CUI_SUCCEEDED';
export const SEARCH_CUI_FAILED = 'SEARCH_CUI_FAILED';

export const SAVE_TERMS_STARTED = 'SAVE_TERMS_STARTED';
export const SAVE_TERMS_SUCCEEDED = 'SAVE_TERMS_SUCCEEDED';
export const SAVE_TERMS_FAILED = 'SAVE_TERMS_FAILED';

export const SAVE_INDEXINGTERMS_STARTED = 'SAVE_INDEXINGTERMS_STARTED';
export const SAVE_INDEXINGTERMS_SUCCEEDED = 'SAVE_INDEXINGTERMS_SUCCEEDED';
export const SAVE_INDEXINGTERMS_FAILED = 'SAVE_INDEXINGTERMS_FAILED';

export const FETCH_TERMS_STARTED = 'FETCH_TERMS_STARTED';
export const FETCH_TERMS_SUCCEEDED = 'FETCH_TERMS_SUCCEEDED';
export const FETCH_TERMS_FAILED = 'FETCH_TERMS_FAILED';

export const SEARCH_ATOMS_STARTED = 'SEARCH_ATOMS_STARTED';
export const SEARCH_ATOMS_SUCCEEDED = 'SEARCH_ATOMS_SUCCEEDED';
export const SEARCH_ATOMS_FAILED = 'SEARCH_ATOMS_FAILED';

export const CLEAR_ATOMS_DATA = 'CLEAR_ATOMS_DATA';
export const CLEAR_SELECTED_TERMS = 'CLEAR_SELECTED_TERMS';
export const CLEAR_SEARCHED_TERMS = 'CLEAR_SEARCHED_TERMS';

export const TERM_CLICKED = 'TERM_CLICKED';
export const TERM_DIALOG_CLOSED = 'TERM_DIALOG_CLOSED';

export const TERMS_PAGE_SELECTED = 'TERMS_PAGE_SELECTED';
